<script>
  import Typetester from "./components.js"
  import { onMount, createEventDispatcher } from "svelte"

  export let editable = false
  export let sentence
  export let text
  export let typeface
  export let focused

  let loaded = false

  const dispatch = createEventDispatcher()

  function onClick(event) {
    if (!editable) return
    event.stopPropagation()
  }

  onMount(() => {
    const font = new FontFace(typeface.name, typeface.src)
    font.load().then(() => {
      document.fonts.add(font)
      loaded = true
      dispatch("loaded")
    })
  })
</script>

<div class:editable class:loaded style="font-family: {typeface.name};">
  {#if editable}
    <Typetester.TypeWriter {focused} bind:text />
  {:else}
    <Typetester.TypeSample {sentence} />
  {/if}
</div>

<style>
  div {
    font-size: inherit;
    line-height: 1em;
    text-align: center;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
    padding-left: 0.1em;
    padding-right: 0.1em;
  }

  .loaded {
    opacity: 1;
  }

  .editable {
    display: block;
  }
</style>
